//components
import {ActionFeedbackBanner, ContentImagePreviewPanel} from "thrive-components";
import CommentInputPanel from "../../elements/commentInputPanel/CommentInputPanel";
import ContentTitle from "../../elements/contentTitle/ContentTitle";
import ActivityInformationPanel from "../../elements/activityInformationPanel/ActivityInformationPanel";
import DeletedBanner from "../../elements/deletedComment/DeletedComment";
import ApprovePanel from "../../elements/approvePanel/ApprovePanel";
import ArchiveContent from "../../elements/archiveContent/ArchiveContent";
import ActivityProfileData from "../../elements/activityProfileData/ActivityProfileData";
import RecognitionPostTitle from "../../elements/notificationTitle/RecognitionPostTitle/RecognitionPostTitle";

//interfaces
import { UserActivity } from "@/interfaces/activityFeed";
import { IRecognitionNotification } from "@/interfaces/activityFeedNotifications";

//hooks
import UseRecognitionPost from "./RecognitionPost.hooks";

//styling
import "../../../../../css/activityFeed/notifications/recognition-content-posted.scss";



const RecognitionPost = ({ zIndexNum, isPopOut = false, timeStamp, dateStamp, user, parentList, content, editorProfileImage, onLikeClick, onPostCommentClick, onArchiveContentClick, isRemovedFromParentList, appDetails, getWebLink, meta, recognition, notificationDetails, isModeratedContent, needsApproval, onApproveClick}: IRecognitionNotification) => {
    const {recognisedUser, screenClassName, webLink, handleLikeClick, handleReplyClick, handleArchiveClick, handleApproveClick, showMenu, commentString, setCommentString, onCommentClick, showCommentFunctionality, setShowCommentFunctionality, showFeedbackBanner, feedbackType,  feedbackMessage, contentIsRemoved, deletedBannerMessage, showApprovalPanel, showArchiveContent, hideArchiveFunctionality, onArchiveClick, activityInfo, isPosting} = UseRecognitionPost({isPopOut, timeStamp, dateStamp, parentList, content, onLikeClick, onPostCommentClick, onArchiveContentClick, isRemovedFromParentList, appDetails, getWebLink, meta, recognition, notificationDetails, isModeratedContent, needsApproval, onApproveClick});

    return (
        <div className={`${isPopOut ? "" : "recognition-content-posted-full"} recognition-content-posted notification-wrapper`}>
            <div className="top-row">
                <ActivityProfileData 
                    isPopOut={isPopOut}
                    userActivity={UserActivity.recognition} 
                    timeStamp={timeStamp}
                    dateStamp={dateStamp}
                    imageUrl={user.imageUrl}
                    secondUserImageUrl={recognisedUser.imageUrl}
                    showSecondUser
                />
                
                <RecognitionPostTitle 
                    parentList={parentList} 
                    user={user.name} 
                    recognisedUser={recognisedUser.name}
                    isPopOut={isPopOut}
                />
            </div>        

            <ContentTitle 
                zIndexNum={zIndexNum}
                className={screenClassName} 
                contentTitle={recognition.text} 
                getWebLink={webLink} 
                onLikeClick={handleLikeClick} 
                isLiked={meta.hasLiked} 
                onReplyClick={handleReplyClick}
                onArchiveContentClick={handleArchiveClick} 
                onApproveContentClick={handleApproveClick}
                showMenu={showMenu}
            />

            <ContentImagePreviewPanel 
                className={screenClassName}  
                mediaItems={content.media} 
                maxVisible={5} 
                totalMediaItems={content.totalMediaItems} 
            />

            <CommentInputPanel
                className={screenClassName}  
                commentString={commentString}
                setCommentString={setCommentString}
                onPostCommentClick={onCommentClick}
                showCommentFunctionality={showCommentFunctionality}
                setShowCommentFunctionality={setShowCommentFunctionality}
                profileImageUrl={editorProfileImage}
                isPosting={isPosting}
            />   

            {showFeedbackBanner && 
                <ActionFeedbackBanner 
                    feedbackType={feedbackType} 
                    feedbackMessage={feedbackMessage} 
                />
            }

            <DeletedBanner 
                isDeleted={contentIsRemoved} 
                message={deletedBannerMessage}
            />

            {showApprovalPanel && 
                <ApprovePanel 
                    className={screenClassName}
                    onApprovalClick={onApproveClick} 
                    needsApproval={needsApproval}
                />
            }
            
            <ArchiveContent 
                showModal={showArchiveContent} 
                existsInMultiplePlaces={content.existsInMultiplePlaces} 
                onCloseClick={hideArchiveFunctionality} 
                onConfirmClick={onArchiveClick}  
                isInlineStyle={isPopOut} 
            />    

            <ActivityInformationPanel
                  {...activityInfo}
            />
        </div>
    )
};

export default RecognitionPost